import { object, string, ref } from 'yup'

export const securitySettingsSchema = object({
    newPassword: string()
        .min(8, 'Password must have atleast 8 characters'),
    confirmPassword: string()
        .oneOf([ref('newPassword'), null], 'Password does not matched')
})